import * as HotelCemFilterService from '@/storage/services/hotelcem/CommonFilterService'
import AuthService from '@hotelcem/apis/auth/authService'
import HomeNewService from '@/hotelcem/apis/home/homeNewService'
import * as AppBaseConfigService from '@/storage/services/AppBaseConfigService'
import xreportStore from '@/xreports/store/index'
// import API_SERVICE_USER from '@/xreports/apis/system/user'
import dayjs from 'dayjs'
import { getUserInfo } from '@/storage/services/AppBaseConfigService'
import Ubt from '@hotelcem/utils/matomoUbt'
import { INDUSTRY_TYPE } from '@/hotelcem/constants/index'

//    ┏┓   ┏┓
//  ┏┛┻━━┛┻┓
//  ┃          ┃
//  ┃   ━     ┃
//  ┃ ┳┛ ┗┳ ┃
//  ┃          ┃
//  ┃   ┻     ┃
//  ┃          ┃
//  ┗━┓   ┏━┛
//     ┃   ┃
//     ┃   ┃
//     ┃   ┗━━━┓
//     ┃         ┣┓
//     ┃          ┏┛
//     ┗┓┓┏━┳┓┏┛
//       ┃┫┫ ┃┫┫
//       ┗┻┛ ┗┻┛
// Codes are far away from bugs with the animal protecting
// 神兽保佑,代码无bug
const getUrlParam = key => {
  var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)') //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg) //匹配目标参数
  if (r != null) {
    return unescape(r[2]) //返回参数值
  } else {
    return null
  }
}
// const oldHotelInfo = JSON.parse(localStorage.getItem('VOCUST_HOTEL_CEM_FILTER_KEY' + getUserInfo().account))

// if (oldHotelInfo) {
//   if (oldHotelInfo.dateRange.length > 0) {
//     let sd = new Date(oldHotelInfo.dateRange[0])
//     let ed = new Date(oldHotelInfo.dateRange[1])
//     oldHotelInfo.dateRange = [sd, ed]
//   }
// }

export default {
  namespaced: true,
  state: {
    windowInnerWidth: window?.innerWidth, // 设备宽度
    dateFilter: {},
    hotelInfo: undefined,
    showPermissionsDialog: false,
    qualityScoreLevel: undefined, // 商圈质检分数等级
    isChangeHotel: false, // 是否手动切换酒店
    currentDepId: undefined, //多店版当前部门ID
    currentDepInfo: {}, // 多店当前部门详情
    hideChildMenu: undefined,
    warningHotelList: [], // 报警酒店列表白名单
    renewList: [], // 续费列表
    renewVisible: false, // 续费弹窗是否显示
    isJms: false, // 是否是jms系統启动
  },
  getters: {
    showNewFn: state => {
      if (state.dateFilter.hotelInfo?.hotelInfo) {
        const { hotelId } = state.dateFilter.hotelInfo.hotelInfo
        return state.warningHotelList.includes(hotelId)
      }
      return false
    },
    getIndustryName:
      state =>
      (hideType = []) => {
        if (state.dateFilter.hotelInfo?.hotelInfo) {
          const { industryType } = state.dateFilter.hotelInfo.hotelInfo
          if (hideType.includes(industryType)) {
            return ''
          }
          const industryInfo = INDUSTRY_TYPE.find(item => item.industryType === industryType) || {}
          return industryInfo.industryName || ''
        }
        return ''
      },
  },
  mutations: {
    SET_IS_CHANGE_HOTEL(state, isChangeHotel) {
      state.isChangeHotel = isChangeHotel
    },
    SET_QUALITY_SCORE_LEVEL(state, qualityScoreLevel) {
      state.qualityScoreLevel = qualityScoreLevel
    },
    SET_WINDOW_INNER_WIDTH(state, payload) {
      state.windowInnerWidth = payload
    },
    // 全局过滤参数
    SET_DATE_FILTER(state, dateFilter) {
      HotelCemFilterService.setHotelCemFilter(dateFilter)
      state.dateFilter = dateFilter
      Ubt.sendEvent('hotelChange')
    },
    SET_WARNING_HOTEL_LIST(state, payload) {
      state.warningHotelList = payload
    },
    SET_HOTEL_INFO(state, options) {
      try {
        let payload = options
        if (options.forceUpdate) {
          payload = options.data
        }
        state.hotelInfo = payload
        // 更新dateFilter
        const dateFilterLocal = HotelCemFilterService.getHotelCemFilter()
        let startdate = getUrlParam('startdate')
        let enddate = getUrlParam('enddate')
        let hotelId = getUrlParam('hotelId')
        let hotelInfo
        // 单店账号,需要自己组装hotelList
        if (payload.type === 2) {
          hotelInfo = VocDeepClone.deepClone(payload)
        } else {
          hotelInfo = payload.hotelList[0]
        }

        // 1. URL存在
        // 2. localstorage中存在
        // 3. 都不存在
        if (options.forceUpdate) {
          startdate = dayjs().subtract(29, 'day').hour(0).minute(0).second(0).millisecond(0).toDate()
          enddate = dayjs().hour(23).minute(59).second(59).millisecond(999).toDate()
          hotelInfo = payload.hotelList.find(item => item.hotelId === payload.hotelId) || hotelInfo
        } else if (hotelId && startdate && enddate) {
          startdate = dayjs(startdate).hour(0).minute(0).second(0).millisecond(0).toDate()
          enddate = dayjs(enddate).hour(23).minute(59).second(59).millisecond(999).toDate()
          hotelInfo = payload.hotelList.find(item => item.hotelId === hotelId) || hotelInfo
        } else if (dateFilterLocal) {
          // state.dateFilter = dateFilterLocal
          // return

          const localHotelId = dateFilterLocal.hotelInfo?.value
          if (localHotelId !== payload.hotelId && !payload.hotelList.find(item => item.hotelId === localHotelId)) {
            // localstorage中无效
            startdate = dayjs().subtract(29, 'day').hour(0).minute(0).second(0).millisecond(0).toDate()
            enddate = dayjs().hour(23).minute(59).second(59).millisecond(999).toDate()
            hotelInfo = payload.hotelList.find(item => item.hotelId === hotelId) || hotelInfo
          } else {
            state.dateFilter = dateFilterLocal
            return
          }
        } else {
          startdate = dayjs().subtract(29, 'day').hour(0).minute(0).second(0).millisecond(0).toDate()
          enddate = dayjs().hour(23).minute(59).second(59).millisecond(999).toDate()
          hotelInfo = payload.hotelList.find(item => item.hotelId === payload.hotelId) || hotelInfo
        }

        state.dateFilter = {
          dateRange: [startdate, enddate],
          hotelInfo: { hotelInfo: hotelInfo, label: hotelInfo.hotelName, value: hotelInfo.hotelId },
        }

        HotelCemFilterService.setHotelCemFilter(state.dateFilter)
        Ubt.sendEvent('hotelChange')
      } catch (error) {
        console.log(error)
        throw { logoutType: 'no hotelcem auth' } // 没有权限
      }
    },
    TOGGLE_PERMISSIONS_STATE(state, status) {
      state.showPermissionsDialog = status
    },
    SET_HOTEL_INFO_BY_ID(state, id) {
      // 根据 酒店ID 重置全局hotelInfo
      const { hotelList } = state.hotelInfo || {}
      if (hotelList && hotelList?.length) {
        let hotelInfo = hotelList.find(item => item.hotelId === id)
        if (hotelInfo) {
          let dateFilter = Object.assign({}, state.dateFilter, {
            hotelInfo: {
              hotelInfo,
              label: hotelInfo.hotelName,
              value: hotelInfo.hotelId,
            },
          })
          HotelCemFilterService.setHotelCemFilter(dateFilter)
          state.dateFilter = dateFilter
        } else {
          let dateFilter = Object.assign({}, state.dateFilter, {
            hotelInfo: {
              hotelInfo: {
                hotelId: id,
                hotelName: '',
                ctripHotelId: '',
                ctripHotelName: '',
                cloudHotelId: '--',
                cloudHotelName: '--',
                type: 1,
                tenantId: '',
                industryType: 1,
              },
              label: '',
              value: id,
            },
          })
          HotelCemFilterService.setHotelCemFilter(dateFilter)
          state.dateFilter = dateFilter
        }
      }
    },
    // 保存默认酒店
    SET_DEFAULT_HOTEL_INFO(state, payload) {
      try {
        const hotelInfo = payload
        HotelCemFilterService.setHotelCemDefault({
          dateRange: state.dateFilter.dateRange,
          hotelInfo: { hotelInfo: hotelInfo, label: hotelInfo.hotelName, value: hotelInfo.hotelId },
        })
      } catch (error) {
        console.log(error)
        throw { logoutType: 'no hotelcem auth' } // 没有权限
      }
    },
    // 保存默认酒店
    SET_VOCUST_HOTEL_CEM_FILTER_KEY(state, payload) {
      try {
        const hotelInfo = payload
        const dateFilter = {
          dateRange: state.dateFilter.dateRange,
          hotelInfo: { hotelInfo: hotelInfo, label: hotelInfo.hotelName, value: hotelInfo.hotelId },
        }
        HotelCemFilterService.setHotelCemFilter(dateFilter)
        if (JSON.stringify(dateFilter) !== JSON.stringify(state.dateFilter)) {
          // 对比一下新老数据，否则赋值会导致很多页面watch重复触发
          state.dateFilter = dateFilter
        }
      } catch (error) {
        console.log(error)
        throw { logoutType: 'no hotelcem auth' } // 没有权限
      }
    },
    // 设置多店版当前部门
    SET_CURRENT_DEP_ID(state, payload) {
      state.currentDepId = payload
    },
    SET_CURRENT_DEP_INFO(state, payload) {
      state.currentDepInfo = payload
    },
    setHideChildMenu(state, hideChildMenu) {
      state.hideChildMenu = hideChildMenu
    },
    setRenewList(state, payload) {
      state.renewList = payload
    },
    setRenewVisible(state, visible) {
      state.renewVisible = visible
    },
    setIsJms(state, isJms) {
      state.isJms = isJms
    },
  },
  actions: {
    async setHotelInfo({ state, commit }) {
      try {
        const tenantId = getUserInfo()?.tenantId
        const stogreHotelInfo = localStorage.getItem('VOCUST_HOTEL_CEM_FILTER_KEY')
        let oldInfo = stogreHotelInfo ? JSON.parse(stogreHotelInfo) : undefined
        let isClearHotelKey = false

        // 不是同一个租户
        if (oldInfo && !(tenantId === oldInfo.hotelInfo.hotelInfo.tenantId)) {
          HotelCemFilterService.clearHotelCemFilter()
          HotelCemFilterService.clearHotelCemDefault()
          isClearHotelKey = true
        }

        const urlHotelId = getUrlParam('hotelId')
        const res = await AuthService.getHotelInfo({ hotelId: urlHotelId })
        if (!res || res.code !== 200) {
          HotelCemFilterService.clearHotelCemFilter()
          HotelCemFilterService.clearHotelCemDefault()
          console.log('error here')
          throw { logoutType: 'no hotelcem auth' } // 没有权限
        }
        // 设置菜单版本
        if (res?.data?.menuVersion) {
          commit('menus/SET_MENU_VERSION', res?.data?.menuVersion, { root: true })
        }
        // 单店账号
        if (res?.data?.type === 2) {
          isClearHotelKey = true
        }

        // console.log('res.data', res.data)
        const hotelInfo = res.data
        if (hotelInfo.hotelId) {
          hotelInfo.hotelList = [
            {
              ...hotelInfo,
              hotelId: hotelInfo.hotelId,
              hotelName: hotelInfo.hotelName,
              ctripHotelId: hotelInfo.ctripHotelId,
              ctripHotelName: hotelInfo.ctripHotelName,
              cloudHotelId: hotelInfo.cloudHotelId,
              cloudHotelName: hotelInfo.cloudHotelName,
              type: hotelInfo.type,
              tenantId: hotelInfo.tenantId,
              industryType: hotelInfo.industryType,
              isCanCorrection: hotelInfo.isCanCorrection,
              isUserCorrection: hotelInfo.isUserCorrection,
              realCtripHotelId: hotelInfo.realCtripHotelId,
            },
          ]

          // 从缓存中获取数据
          if (oldInfo && !isClearHotelKey) {
            if (tenantId === oldInfo.hotelInfo.hotelInfo.tenantId) {
              let oldID = oldInfo.hotelInfo.hotelInfo?.value || oldInfo.hotelInfo.hotelInfo?.hotelId
              if (!hotelInfo.hotelList.find(item => item.hotelId === oldID)) {
                hotelInfo.hotelList.unshift(oldInfo.hotelInfo.hotelInfo)
              }
            }
          }
        }
        let hotelLogos = localStorage.getItem('hotelLogos') ? JSON.parse(localStorage.getItem('hotelLogos')) : {}
        hotelInfo.hotelLogoMap = {
          ...hotelInfo.hotelLogoMap,
          ...hotelLogos,
        }

        // const url = new URL(location.href)
        // const reportHotelId = url.searchParams ? url.searchParams.get('hotelId') : getUrlParam('hotelId')
        // if (
        //   reportHotelId &&
        //   hotelInfo.hotelId !== reportHotelId &&
        //   !hotelInfo.hotelList.find(item => item.hotelId === reportHotelId)
        // ) {
        //   HotelCemFilterService.clearHotelCemFilter()
        //   throw { logoutType: 'illegal link' } // 非法链接
        // }

        commit('SET_HOTEL_INFO', hotelInfo)
        const uesrInfo = {
          ...AppBaseConfigService.getAppBaseConfig().userInfo,
          type: hotelInfo.type,
        }
        AppBaseConfigService.setUserInfo(uesrInfo)
        xreportStore?.commit('systemUser/setUserInfo', uesrInfo)

        // 保存默认酒店
        if (!urlHotelId) commit('SET_DEFAULT_HOTEL_INFO', hotelInfo)
      } catch (error) {
        console.error(error)
        xreportStore?.dispatch('systemUser/logout', error)
      }
    },
    async getExpireNotice({ commit }, params) {
      try {
        const res = await HomeNewService.getExpireNotice({
          hotelId: params.hotelId,
        })
        if (!res || res.successful !== true) {
          throw { logoutType: 'no hotelcem auth' } // 没有权限
        }
        const data = res.data || {}
        if (data?.isManager) {
          commit('setRenewList', data.dataList || [])
          commit('setRenewVisible', data.dataList.length > 0)
        } else {
          commit('setRenewList', [])
          commit('setRenewVisible', false)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async setHotelInfoById({ commit }, hotelId) {
      try {
        const res = await AuthService.getHotelInfo({ hotelId })
        if (!res || res.code !== 200) {
          throw { logoutType: 'no hotelcem auth' } // 没有权限
        }
        const hotelInfo = res.data
        hotelInfo.hotelList = [
          {
            ...hotelInfo,
            hotelId: hotelInfo.hotelId,
            hotelName: hotelInfo.hotelName,
            ctripHotelId: hotelInfo.ctripHotelId,
            ctripHotelName: hotelInfo.ctripHotelName,
            cloudHotelId: hotelInfo.cloudHotelId,
            cloudHotelName: hotelInfo.cloudHotelName,
            type: hotelInfo.type,
            tenantId: hotelInfo.tenantId,
            industryType: hotelInfo.industryType,
            isCanCorrection: hotelInfo.isCanCorrection,
            isUserCorrection: hotelInfo.isUserCorrection,
            realCtripHotelId: hotelInfo.realCtripHotelId,
          },
        ]
        commit('SET_HOTEL_INFO', { forceUpdate: true, data: hotelInfo })
      } catch (error) {
        console.error(error)
      }
    },
  },
}
